import React from 'react';
import PropTypes from 'prop-types';
import { Link, VStack } from '@chakra-ui/react';
import { Text } from '@outdoorly/text';
import { Container } from '@outdoorly/container';
import { Button } from '@outdoorly/button';

import NextImage from 'next/image';
import NextLink from 'next/link';
import travolta from '../public/images/compressed-travolta.gif';

export const NoProducts = ({ type = 'page' }) => {
  return (
    <Container
      as={VStack}
      spacing={12}
      maxWidth={['full', null, '2xl']}
      py={[8, 8, 16]}
    >
      <NextImage width="200px" height="190px" src={travolta} />
      <Text size="2xl" fontWeight="500" align="center">
        We couldn&apos;t find any products to show you{' '}
        <span role="img" aria-label="Sad face">
          😞
        </span>
      </Text>
      <Text size="lg" color="scheme.textSecondary" align="center">
        This is embarrassing on our part. You found a {type} that doesn&apos;t
        have any products listed. Try{' '}
        <Link
          href="/profile/qualifications"
          color="scheme.textSecondary"
          textDecoration="underline"
        >
          adding a new qualification
        </Link>
        . It might grant you additional access to exclusive products.
      </Text>
      <NextLink href="/" passHref>
        <Button
          as="a"
          size="lg"
          w="sm"
          variant="solid"
          colorScheme="red"
          maxW="full"
        >
          Continue shopping
        </Button>
      </NextLink>
    </Container>
  );
};

NoProducts.propTypes = {
  type: PropTypes.string,
};
